const filterBattons = [
    {title: "All", classActive: 'active'},
    {title: "Crypto"},
    {title: "E-commerce"},
    {title: "NFT"},
    {title: "Dashboards"}
];

export default filterBattons;